import styled from 'styled-components';

export const StyledForm = styled.form`
  min-width: 353px;
  overflow-y: overlay;
  max-height: 100%;
  padding-right: 20px;
`;
